module.exports = __webpack_public_path__ + "static/game-picture-6d7418cbdce2da11466668f2d9d2658e.png";